<app-card-header-loader *ngIf="isLoading | async; else detailTpl" />
<ng-template #detailTpl>
  <app-card [cardClasses]="'mb-8'" [header]="!!title" [cardHeaderTitle]="title" [cardBodyClasses]="title ? 'pt-0' : ''">
    <ng-container cardBody *ngIf="data | async as data">
      <div class="row align-items-start">
        <div class="col-12 col-md" *ngFor="let value of data">
          <div class="font-12 fw-semibold text-gray-500 mb-2">{{ value.name }}</div>
          <h1 class="text-gray-800">{{ value.value }}</h1>
        </div>
      </div>
    </ng-container>
  </app-card>
</ng-template>
